module.exports = __webpack_public_path__ + "img/index11.ca06c7b5.png";